/**
 * Component: Quantity selector
 * ------------------------------------------------------------------------------
 * A form control component to increment/decrement a counter.
 *
 * @namespace quantitySelector
 */

import bind from '../mixins/bind'

import log from 'salvo-lite/log'

class QuantitySelector {
    constructor (theme, elem) {
        this._theme = theme
        this._elem = elem
        this._settings = {
            decrement: '[data-quantity-selector-decrement]',
            increment: '[data-quantity-selector-increment]',
            input: '[data-quantity-selector-input]',
            id: null,
            ...JSON.parse(elem.getAttribute('data-quantity-selector') || '{}')
        }

        /**
         * Node selectors.
         */
        this._nodeSelectors = {
            decrement: this._elem.querySelector(this._settings.decrement),
            increment: this._elem.querySelector(this._settings.increment),
            input: this._elem.querySelector(this._settings.input)
        }

        /**
         * Initialise component bind.
         */
        this._binder = bind(this._elem)
        this._timer = {}

        log.debug(this.constructor.name, 'Constructed', this)
    }

    /**
     * Initialise component.
     */
    onInit () {
        if (this._binder && this._binder.isSet()) {
            return
        }

        this._setListeners()
        this._setTriggerEvents()
        this._binder.set()
    }

    /**
     * Set listeners for each instance.
     */
    _setListeners () {
        window.Frame.EventBus.listen(`AjaxCart:${this._settings.id}:update`, (value) => {
            this._update(value)
            this._executeCallback()
        })
    }

    /**
     * Set click listeners.
     */
    _setTriggerEvents () {
        this._nodeSelectors.increment.addEventListener('click', e => this._handleQuantityUpdate('increment', event))
        this._nodeSelectors.decrement.addEventListener('click', e => this._handleQuantityUpdate('decrement', event))
    }

    /**
     * Handle quantity updates.
     * @param {string} type - Quantity update type (increment/decrement).
     * @param {Event} event - Click event.
     */
    _handleQuantityUpdate (type, event) {
        event.preventDefault()
        const inputValue = this._nodeSelectors.input.value
        const currentValue = (type === 'increment') ? parseInt(inputValue, 10) + 1 : parseInt(inputValue, 10) - 1

        if (this._validate(currentValue)) {
            window.Frame.EventBus.emit(`AjaxCart:${this._settings.id}:update`, currentValue)
        }

        if (this._elem.dataset.installation === 'installation' && currentValue === 1) {
            window.setTimeout(() => {
                window.location.reload()
            }, 500)
        }
    }

    /**
     * Validate input.
     * @param {Integer} value - Value to validate.
     */
    _validate (value) {
        return (!isNaN(value) && value >= 1)
    }

    /**
     * Update DOM value and execute callback.
     * @param {Integer} value - Value to replace on DOM.
     */
    _update (value) {
        this._nodeSelectors.input.setAttribute('value', value)
    }

    /**
     * Execute callback _defined in constructor.
     */
    _executeCallback () {
        switch (this._settings.callback) {
        case 'cart-table':
            window.clearTimeout(this._timer)
            this._timer = window.setTimeout(() => {
                this._elem.dispatchEvent(new Event('quantitySelectorInitialised'))
            }, 250)
            break
        default:
        }
    }

    _setCallback () {
    }

    /**
     * Expose public interface.
     */
    // return Object.freeze({
    //   init,
    //   update,
    // });
}

export default QuantitySelector



// WEBPACK FOOTER //
// ./src/resources/scripts/components/QuantitySelector.js